<script setup>
import CustomFieldStatusType from '@/components/customFields/CustomFieldStatusType.vue'
import CustomFieldBooleanType from '@/components/customFields/CustomFieldBooleanType.vue'
import CustomFieldHtmlType from '@/components/customFields/CustomFieldHtmlType.vue'
import CustomFieldUrlType from '@/components/customFields/CustomFieldUrlType.vue'
import CustomFieldDefaultType from '@/components/customFields/CustomFieldDefaultType.vue'

const props = defineProps({
    project: {
        type: Object,
        required: true
    },
    unit: {
        type: Object,
        required: true
    },
    fieldKey: {
        type: String,
        required: true
    }
})

const customFieldRenderer = useCustomFieldRenderer(props.project, props.unit, props.fieldKey)
const { field } = customFieldRenderer

const componentType = computed(() => {
    if (!field) return CustomFieldDefaultType

    if (field.type === 'status') {
        return CustomFieldStatusType
    } else if (field.type === 'boolean') {
        return CustomFieldBooleanType
    } else if (field.type === 'html') {
        return CustomFieldHtmlType
    } else if (field.type === 'url') {
        return CustomFieldUrlType
    } else {
        return CustomFieldDefaultType
    }
})
</script>
<template>
    <component
        :is="componentType"
        :project="props.project"
        :unit="props.unit"
        :fieldKey="props.fieldKey"
    >
        <template #hide="scope">
            <slot name="hide" v-bind="scope" />
        </template>
        <template #hidden="scope">
            <slot name="hidden" v-bind="scope" />
        </template>
        <template #prefix="scope">
            <slot name="prefix" v-bind="scope" />
        </template>
        <template #suffix="scope">
            <slot name="suffix" v-bind="scope" />
        </template>
        <template #default="scope">
            <slot name="default" v-bind="scope" />
        </template>
    </component>
</template>
